// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapper[data-v-e4b2ed70] {\n  width: 100%;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 0;\n}\n.icon[data-v-e4b2ed70] {\n  width: 7rem;\n  height: auto;\n}\np[data-v-e4b2ed70] {\n  font-size: 1.8rem;\n  max-width: 18.4rem;\n}\n", ""]);
// Exports
module.exports = exports;
